import { Badge, Button, ModalContainer, ModalContent, ModalHeader } from '@trm/ui-kit-admin';

export type WhatsNewEntry = {
  id: string;
  date: string;
  title: string;
  body: string;
  isNew: boolean;
  isBeta: boolean;
  onTry: (() => void) | null;
};

const Entry = ({ entry }: { entry: WhatsNewEntry }) => (
  <li className="flex flex-col gap-2 border-b border-secondary py-5 last:border-b-0">
    <div className="flex flex-wrap items-center gap-2">
      <p className="text-xs text-tertiary">{entry.date}</p>
      {entry.isNew && (
        <Badge color="brand" size="sm">
          New
        </Badge>
      )}
      {entry.isBeta && (
        <Badge color="gray" size="sm">
          Beta
        </Badge>
      )}
    </div>
    <h3 className="text-md font-semibold text-primary">{entry.title}</h3>
    <p className="text-sm text-tertiary">{entry.body}</p>
    {entry.onTry && (
      <div>
        <Button size="sm" color="secondary" onClick={entry.onTry}>
          Try it
        </Button>
      </div>
    )}
  </li>
);

export const WhatsNewPanel = ({
  entries,
  onClose,
}: {
  entries: readonly WhatsNewEntry[];
  onClose: () => void;
}) => (
  <ModalContainer className="flex max-h-[calc(100dvh-6rem)] flex-col" onClose={onClose}>
    <ModalHeader title="What's new" subtitle="Recent changes to the admin app." divider />
    <ModalContent className="min-h-0 overflow-y-auto">
      <ul>
        {entries.map((entry) => (
          <Entry key={entry.id} entry={entry} />
        ))}
      </ul>
    </ModalContent>
  </ModalContainer>
);
